/** ****************************************************************************
 * CSS Sanitization Utility
 *
 * Strips dangerous CSS patterns from partner-supplied custom CSS before
 * it is transformed and applied via Aphrodite. This prevents CSS injection
 * attacks including JavaScript execution, data exfiltration, and external
 * resource loading.
 *
 * @file   CSS sanitization for partner-supplied customCss.content
 * @since  2.0.0
 **************************************************************************** */

const DANGEROUS_PATTERNS: RegExp[] = [
  /expression\s*\(/gi,
  /-moz-binding\s*:/gi,
  /behavior\s*:/gi,
  /javascript\s*:/gi,
  /@import\b/gi,
  /url\s*\(/gi,
]

/**
 * Sanitizes a CSS string by removing patterns that could be used for
 * injection attacks (JS execution, data exfiltration, external resources).
 *
 * @param cssContent Raw CSS string from partner
 * @returns Sanitized CSS string safe for transformation
 */
export function sanitizeCss(cssContent: string): string {
  let sanitized = cssContent
  for (const pattern of DANGEROUS_PATTERNS) {
    sanitized = sanitized.replace(pattern, '/* removed */')
  }
  return sanitized
}
